import { getUserLang } from '../../lib/helper';
import { LocalizationService } from '../localization.service';
import { IInjectedServices } from './injected-services';

export default function createServices(): IInjectedServices {
	
	const localizationService = new LocalizationService(getUserLang());

	return { localizationService };
}
